<template>
  <div v-if="hotspot.fileUrl" class="hotspot">
    <BaseImageExternal :src="hotspot.fileUrl" class="hotspot-image" />
  </div>
</template>

<script setup lang="ts">
import { type HotspotImageEntity } from "~/graphql/generated";

const props = defineProps<{
  hotspot: HotspotImageEntity;
}>();

const x = ref(`${props.hotspot.x * 100}%`);
const y = ref(`${props.hotspot.y * 100}%`);
const width = ref(`${props.hotspot.width * 100}%`);
const height = ref(`${props.hotspot.height * 100}%`);
</script>

<style lang="scss" scoped>
.hotspot {
  position: absolute;
  z-index: 3;
  left: v-bind(x);
  top: v-bind(y);
  width: v-bind(width);
  height: v-bind(height);
  display: flex;
  align-items: center;
  justify-content: center;

  .hotspot-image {
    width: 100%;
    height: 100%;
  }
}
</style>
